import React from 'react';
import { TreeSectionTitle } from '../TreeSectionTitle';
import style from './CategoryLink.scss';

export const CategoryLink = ({
  onLinkClick,
  onExpandButtonClick,
  link,
  title,
  isExpanded,
  type,
  shouldShowPimple,
}) => (
  <div className={style.treeSectionTitle} data-hook="category-link">
    <TreeSectionTitle
      onExpandButtonClick={onExpandButtonClick}
      isExpanded={isExpanded}
      link={link}
      title={title}
      type={type}
      onClick={onLinkClick}
      shouldShowPimple={shouldShowPimple}
    />
  </div>
);
